(function () {
    'use strict';

    angular
        .module('app')
        .directive('adminComments', adminCommentsDirective);

    function adminCommentsDirective() {
        var directive = {
            restrict: 'AE',
            scope: {
                resource: '@',
                pk: '=',
            },
            controller: adminCommentsDirectiveController,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: '/templates/directives/admin-comments.directive.html',
        };


        return directive;
    }

    adminCommentsDirectiveController.$inject = ['API', 'debug', '$timeout', 'alert', 'global',];

    function adminCommentsDirectiveController(API, debug, $timeout, alert, global) {
        var vm = this;
        vm.loaded = false;
        vm.items = [];
        vm.postComment = postComment;
        vm.openRemoveModal = openRemoveModal;
        vm.isSaving = false;
        vm.global = global;
        vm.comment = '';
        vm.isSaving = false;
        activate();

        function activate() {

            loadComments();
        }

        function loadComments() {
            if (!vm.loaded) {
                var promise = {};
                // Post id must be loaded before loading comments.
                if (vm.pk) {
                    promise = API[vm.resource].getComments({
                        id: vm.pk,
                        expand: 'user',
                        sort: '-created',
                    }).$promise;
                    promise.then(function (response) {
                        if (response.items) {
                            vm.items = response.items;
                        }
                    }, function () {
                        debug.log('Error loading comments.');
                    })
                        .finally(function () {
                            vm.loaded = true;
                        });
                } else {
                    $timeout(function () {
                        loadComments();
                    }, 1000);
                }
            }
        }

        function postComment() {
            vm.isSaving = true;
            var promise = API[vm.resource].postComment({
                id: vm.pk,
                expand: 'user',
            }, {
                comment: vm.comment,
            }).$promise;

            promise
                .then(function (response) {
                    if (response) {
                        vm.items.unshift(response);
                    }

                    vm.comment = '';
                }, function () {
                })
                .finally(function () {
                    vm.isSaving = false;
                });
        }

        function openRemoveModal(commentId) {
            var promise = alert.confirm('remove-comment');

            promise.then(function () {
                API[vm.resource].deleteComment({
                    id: vm.pk,
                    target: commentId
                });

                vm.items.forEach(function (item, index) {
                    if (item.id === commentId) {
                        vm.items.splice(index, 1);
                    }
                });
            }, function () {
                debug.log('Canceled.');
            });
        }

    }
})();